import React from 'react';
import s from '../main-header.scss';
export const MobileMenuToggle = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { type: "checkbox", id: "mobileMenuToggle", className: s.mobileMenuToggle }),
        React.createElement("label", { className: `${s.mobileTrigger} ${s.mobileIcon}`, htmlFor: "mobileMenuToggle" },
            React.createElement("span", { className: s.stripe }),
            React.createElement("span", { className: s.stripe }),
            React.createElement("span", { className: s.stripe }))));
};
//# sourceMappingURL=MobileMenuToggle.js.map